'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import type { Dispatch, SetStateAction } from 'react';
import { MentoringCard } from '../../_components/MentoringCard';
import { AdvancedMentoringManager } from './AdvancedMentoringManager';
type AdvancedMentoringProps = {
  activeSubscriptionTab: Subscription;
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  setAdvancedMentoringProduct: Dispatch<SetStateAction<AdvancedMentoringProductDTO>>;
};
export function AdvancedMentoring(t0) {
  const $ = _c(4);
  const {
    activeSubscriptionTab,
    advancedMentoringProduct,
    setAdvancedMentoringProduct
  } = t0;
  let t1;
  if ($[0] !== activeSubscriptionTab || $[1] !== advancedMentoringProduct || $[2] !== setAdvancedMentoringProduct) {
    t1 = <MentoringCard title="Mentoring rozszerzony" details={"Wszystko co w mentoringu podstawowym + dodatkowe opcje dostosowane do Twoich potrzeb. Zawiera nielimitowany dost\u0119p do wszystkich kurs\xF3w grupowych AlgoAcademy oraz indywidualn\u0105 opiek\u0119 mentora. Mo\u017Cesz dodatkowo dostosowa\u0107:"} dark={true}><AdvancedMentoringManager activeSubscriptionTab={activeSubscriptionTab} advancedMentoringProduct={advancedMentoringProduct} setAdvancedMentoringProduct={setAdvancedMentoringProduct} /></MentoringCard>;
    $[0] = activeSubscriptionTab;
    $[1] = advancedMentoringProduct;
    $[2] = setAdvancedMentoringProduct;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}